import { PageKeys, URLS } from 'consts/api';

export enum Languages {
	EN = 'EN',
	IS = 'IS'
}

export type Language = keyof typeof Languages;

export type LanguageState = ReturnType<typeof buildLanguageState>;

export const LANGUAGES = [Languages.IS, Languages.EN];

export type Translations = {
	[lang in Language]: {
		[page in PageKeys]: {
			[key: string]: string;
		};
	};
};

export const LANGUAGE_PAYLOADS = {
	EN: {
		currency: 'USD',
		decimalSeparator: '.',
		language: Languages.EN,
		locale: 'en-US',
		thousandSeparator: ','
	},
	IS: {
		currency: 'ISK',
		decimalSeparator: ',',
		language: Languages.IS,
		locale: 'is-IS',
		thousandSeparator: '.'
	}
};

const translations: Translations = {
	EN: Object.keys(URLS.content).reduce(buildPageTranslations, {}),
	IS: Object.keys(URLS.content).reduce(buildPageTranslations, {})
};

export function buildLanguageState() {
	return { ...LANGUAGE_PAYLOADS.IS, translations };
}

function buildPageTranslations(map: any, page: string) {
	map[page as PageKeys] = {};
	return map;
}
